import * as catalogos from 'app/idiomas/i18n/perfiles/catalogos/pt';
export const locale = {
  lang: 'pt',
  data: {
    'ODS': {
      'TITULO': 'Perfil de companhia',
      'TOOLBAR': {
        'NUEVA': 'Crie o perfil de uma empresa',
        'EDITAR': 'Você pode modificar os dados do perfil desta empresa',
        'CAMBIOS': '(as alterações são salvas automaticamente)',
        'DESCARGAR': 'Baixar informações da empresa'
      },
      'FORMULARIOS': {
        '0': 'Informações da Empresa',
        '1': 'Gestor de projeto',
        '2': 'Diretor de RH',
        '3': 'gerente de TI',
      },
      'BOTONES': {
        'BACK': 'Anterior',
        'NEXT': 'Próximo',
        'ACEPTAR': 'Aceitar'
      },
      'MODALES': {
        'EMPRESA_EXISTE': 'Já existe uma empresa registrada com o nome especificado, tente criar a empresa novamente com outro nome',
        'ERROR_GUARDADO': 'Ocorreu um erro ao criar a empresa, tente novamente mais tarde',
        'GUARDANDO': 'Salvando alterações',
        'GENERANDO_PDF': 'Gerando arquivo PDF, aguarde um momento'
      },
      'CAMPOS': {
        'institutoEmpresa': 'Corretor ',
        'country_application': 'País corretor',
        'nombreEmpresa': 'Empresa',
        'shortName': 'Nome abreviado da empresa',
        'nombrePublicacion': 'Nome da empresa para publicação',
        'account_id': 'ID da conta',
        'idSalesForce': 'ID de SalesForce',
        'codigoProyecto': 'Código do projeto',
        'anioFundacion': 'ano de fundação',
        'empleadosCompleto': 'Funcionários em tempo integral',
        'empleadosParcial': 'Funcionários a tempo parcial',
        'totalColaboradores': 'Número total de colaboradores',
        'sector': 'Selecione um setor',
        'subSector': 'Selecione um subsetor',
        'multinacional': 'Multinacional',
        'name_multinational_group':'Nome do grupo multinacional',
        'region': 'Selecione uma região',
        'pais': 'País',
        'estado': 'Estado, cidade ou província',

        'nombreResponsable': 'Nome',
        'apellidoResponsable': 'Último nome',
        'emailResponsable': 'O email',
        'telResponsable': 'Telefone',
        'extResponsable': 'Extensão',
        'celResponsable': 'Móvel',

        'nombreRH': 'Nome completo',
        'emailRH': 'O email',
        'telRH': 'Telefone',
        'extRH': 'Extensão',
        'celRH': 'Móvel',

        'nombreTI': 'Nome completo',
        'emailTI': 'O email',
        'telTI': 'Telefone',
        'extTI': 'Extensão',
        'celTI': 'Móvel',

        'PDF_sector': 'Setor',
        'PDF_subSector': 'Subsetor',
        'PDF_region': 'Região',
        'PDF_fecha': 'Encontro:',
        'PDF_hora': 'Hora:',
      },
      'CATALOGOS': {
        'institutoEmpresa': catalogos.institutos,
        'sector': catalogos.sectores,
        'region': catalogos.regiones,
        'multinacional': {
          '1': 'sim',
          '2': 'Não',
        }
      },
      'ERRORES': {
        'minlength': 'Você não inseriu o número mínimo de caracteres permitido',
        'maxlength': 'Você excedeu o número máximo de caracteres permitidos',
        'max': 'O número inserido excede o máximo permitido',
        'min': 'O número inserido é menor que o mínimo exigido',
        'pattern': 'O texto inserido contém caracteres não permitidos neste campo',
        'email': 'O texto inserido não está no formato de e-mail correto',
        'required': 'Este campo é obrigatório',
        'TEXT_ESPEC_ANIOFUNDA': 'A data introduzida excede o máximo permitido',
      }
    }
  }
};
